module.exports = __webpack_public_path__ + "static/media/givesounds-2-fix.83a9b773.jpg";